module.exports = __webpack_public_path__ + "img/b7adb0e.jpg";